import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
//@ts-ignore
import { PermissionRequired, AccessControl} from "@careinfo/permission-required";
import MerchantUserList from "../../pages/Merchant User/MerchantUserList";
import MerchantCreateUser from "../../pages/Merchant User/MerchantCreateUser";
import MerchantEditUser from "../../pages/Merchant User/MerchantEditUser";
import MerchantUserProfile from "../../pages/Merchant User/MerchantUserProfile";

export const queryClient = new QueryClient()

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route path="/" element={<MerchantUserList />} />
          <Route path="/users" element={<MerchantUserList />} />
          <Route path="/create" element={
            <AccessControl
            children={
            <MerchantCreateUser/>
            }
            allowedPermissions={["can_create_user"]}
            renderNoAccess={<PermissionRequired/>}
            />
          } />
          <Route path="/edit/:id" element={
              <AccessControl
              children={
                <MerchantEditUser />
              }
              allowedPermissions={["can_update_user"]}
              renderNoAccess={<PermissionRequired/>}
              />
            } />
          <Route path="/profile" element={<MerchantUserProfile />} />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={500} draggablePercent={30} />
    </QueryClientProvider>

  );
};

export default Router;